import {Injectable} from '@angular/core';
import {ProviderType} from '../../../../webmate/shared/console/interfaces/console-config.interface';
import {ToolbarPluginType} from './toolbar-plugin.interface';
import {Point} from '../../../../assets/consoles/openstf/commons';
import {PersistenceService} from '@webmate-web-core/shared/services/persistence.service';

@Injectable({
    providedIn: 'root'
})
export class ConfigPersistenceService {

    // store: open tools,docking status of open tools, position of tools, config of tools (e.g. openstf quality)
    constructor(private persistenceService: PersistenceService) {
    }

    cookiePrefix(type: ProviderType) {
        return `wmc-${type.toLowerCase()}`;
    }

    storePosition(type: ProviderType, t: ToolbarPluginType, p: Point) {
        this.persistenceService.setObjectItem(`${this.cookiePrefix(type)}-${t.toString()}-position`, p);
    }

    getStoredPosition(type: ProviderType, t: ToolbarPluginType): Point | undefined {
        return this.persistenceService.getObjectItem(`${this.cookiePrefix(type)}-${t.toString()}-position`) as Point;
    }

    storeDimensions(type: ProviderType, t: ToolbarPluginType, d: { width: number; height: number }) {
        this.persistenceService.setObjectItem(`${this.cookiePrefix(type)}-${t.toString()}-dimension`, d);
    }

    getStoredDimensions(type: ProviderType, t: ToolbarPluginType): { width: number; height: number } | undefined {
        return this.persistenceService.getObjectItem(`${this.cookiePrefix(type)}-${t.toString()}-dimension`) as {
            width: number;
            height: number
        };
    }

    storeOpenedState(type: ProviderType, t: ToolbarPluginType, state: boolean) {
        this.persistenceService.setObjectItem(`${this.cookiePrefix(type)}-${t.toString()}-toggled`, {state});
    }

    getOpenedState(type: ProviderType, t: ToolbarPluginType): boolean | undefined {
        return this.persistenceService.getObjectItem(`${this.cookiePrefix(type)}-${t.toString()}-toggled`)?.['state'];
    }

    storeLockedState(type: ProviderType, t: ToolbarPluginType, state: boolean) {
        this.persistenceService.setObjectItem(`${this.cookiePrefix(type)}-${t.toString()}-locked`, {state});
    }

    getLockedState(type: ProviderType, t: ToolbarPluginType): boolean | undefined {
        return this.persistenceService.getObjectItem(`${this.cookiePrefix(type)}-${t.toString()}-locked`)?.['state'];
    }

    storeCustomData(type: ProviderType, t: ToolbarPluginType, key: string, value: any) {
        this.persistenceService.setObjectItem(`${this.cookiePrefix(type)}-${t.toString()}-${key}`, value);
    }

    getCustomData(type: ProviderType, t: ToolbarPluginType, key: string): any {
        return this.persistenceService.getObjectItem(`${this.cookiePrefix(type)}-${t.toString()}-${key}`);
    }


}
